module.exports = "https://static.energy5.com/_next/static/images/book-78bd4a7a45414d09e02e8dc9f49fd448.png";